export function isStructuredTextEmpty(text: any): boolean {
	if (!text || typeof text !== 'object') return true

	const document = text?.value?.document
	if (!document || !Array.isArray(document.children) || document.children.length === 0) return true

	// Verify if the first child has empty text
	return document.children.every(
		(child: any) =>
			!child.children ||
			child.children.length === 0 ||
			child.children.every((subChild: any) => subChild.value?.trim() === '')
	)
}
